import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CORE_API_URL } from '../../app.constants';

import { Region } from './region.model';
import { createRequestOption } from '../../shared';

type EntityResponseType = HttpResponse<Region>;
type EntityArrayResponseType = HttpResponse<Region[]>;

@Injectable()
export class RegionService {

    private resourceUrl =  CORE_API_URL + '/v1/regions';
    private resourceUrlNoAuth =  CORE_API_URL + '/v1/noauth/regions';

    constructor(private http: HttpClient) { }

    create(region: Region): Observable<EntityResponseType> {
        const copy = this.convert(region);
        return this.http.post(this.resourceUrl, copy, { observe: 'response' });
    }

    update(region: Region): Observable<EntityResponseType> {
        const copy = this.convert(region);
        return this.http.put(this.resourceUrl, copy, { observe: 'response' });
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http.get(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<Region[]>(this.resourceUrlNoAuth, { params: options, observe: 'response' });
    }

    delete(id: number): Observable<Object> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

    /**
     * Convert a Region to a JSON which can be sent to the server.
     */
    private convert(region: Region): Region {
        const copy: Region = Object.assign({}, region);
        return copy;
    }
}
